'use client';

// internal
import { useGetPermission } from '../../features/permission/query/permission';
import Loading from '../loading/Loading';

const Permission = () => {
  const { isLoading } = useGetPermission('fullloop:composer-app');

  return <Loading loading={isLoading} />;
};

export default Permission;
